/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForComplianceStandard extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForComplianceStandard");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForComplianceStandard.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForComplianceStandard>): BackgroundJobPayloadForComplianceStandard {
        let obj = Object.assign(new BackgroundJobPayloadForComplianceStandard(), model);
        BackgroundJobPayloadForComplianceStandard.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForComplianceStandard>): BackgroundJobPayloadForComplianceStandard {
        if (!model) return null;
        return BackgroundJobPayloadForComplianceStandard.newInstance(<BackgroundJobPayloadForComplianceStandard> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForComplianceStandard) {
        if (!obj) return;

        models.BackgroundJobPayloadForComplianceStandard.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForComplianceStandard): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForComplianceStandard.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    tenant_id: string;

    user_id: string;

    service_accounts: Array<string>;

    assessment_jobs: { [key: string]: string; };

    compliance_uri: string;

}
